import { AppBar } from '@material-ui/core';
import React, { Component } from 'react';
import MobileStoreButton from 'react-mobile-store-button';
import FB from '../../Assets/images/commonImages/facebook.svg';
import Insta from '../../Assets/images/commonImages/instagram.svg';
import Twitter from '../../Assets/images/commonImages/twitter.svg';
import YT from '../../Assets/images/commonImages/youtube.svg';
// import { pushTrackingEventsToGAAndFB } from '../../global/commonFunctions/GaAndFb';
import { globalVal } from '../../global/globalvalues';
import './footer.scss';
type initialProps = {
    background?: string;
    className?: string;
    isFixed?: boolean;
};

type initialState = {
    isPostActive: boolean;
};
export default class Footer extends Component<initialProps, initialState> {
    state = {
        isPostActive: false,
    };
    componentDidMount() {
        let customerDetail: any = localStorage.getItem('customerDetail');
        customerDetail = JSON.parse(customerDetail);
        if (customerDetail && customerDetail?.simPaid && customerDetail?.status === 2) {
            this.setState({ isPostActive: true });
        }
    }
    handleAssuranceCard = () => {
        let assuranceCardUrl: any = globalVal && globalVal.assuranceCardUrl;
        window.open(assuranceCardUrl, 'assurance_card', 'height=450,width=450');
    };

    // GAAndFBEventsHandler = (category: string, actionType: string) => {
    //     pushTrackingEventsToGAAndFB({
    //         category: category,
    //         actionType: actionType,
    //     });
    // };

    render() {
        return (
            <AppBar
                // position={!this.props.isFixed ? 'absolute' : 'static'}
                position="static"
                className={`footer ${this.props.className}`}
                style={{ background: this.props.background ? this.props.background : '#000000', marginTop: '90px' }}
            >
                <div className="footerInner">
                    <div className="Line"></div>
                    <div className="links">
                        <div className="links1">
                            <MobileStoreButton
                                className="android"
                                width={140}
                                height={45}
                                store="android"
                                url={globalVal.androidUrl}
                                linkProps={{ title: 'android Store Button' }}
                            />
                            <MobileStoreButton
                                className="ios"
                                width={140}
                                height={45}
                                store="ios"
                                url={globalVal.IOSURL}
                                linkProps={{ title: 'iOS Store Button' }}
                            />
                        </div>
                        <div className="moreLinks">
                            <div className="links2">
                                <div
                                    className="subLinks"
                                    onClick={() => {
                                        window.open('https://www.astound.com/about-us/');
                                        // this.GAAndFBEventsHandler('Footer', 'About Astound');
                                    }}
                                >
                                    About Astound
                                </div>
                                <div
                                    className="subLinks"
                                    onClick={() => {
                                        window.open('https://www.astound.com/support/');
                                        // this.GAAndFBEventsHandler('Footer', 'Help & Support');
                                    }}
                                >
                                    Help & Support
                                </div>
                                <div
                                    className="subLinks"
                                    onClick={() => {
                                        window.open('https://www.astound.com/welcome/');
                                        // this.GAAndFBEventsHandler('Footer', 'Welcome Center');
                                    }}
                                >
                                    Welcome Center
                                    {/* <img alt="" src={New} className="newTag" /> */}
                                </div>
                                <div
                                    className="subLinks"
                                    onClick={() => {
                                        window.open(process.env.REACT_APP_ASTOUND_TERMS_AND_CONDITIONS_URL);
                                        // this.GAAndFBEventsHandler('Footer', 'Terms & Conditions');
                                    }}
                                >
                                    Terms & Conditions
                                </div>
                            </div>
                            <div className="appsLink">
                                <div
                                    className="icons"
                                    onClick={() => {
                                        window.open(globalVal.facebook, '_blank');
                                        // this.GAAndFBEventsHandler('Footer', 'Facebook');
                                    }}
                                >
                                    <img src={FB} alt="Facebook icon" height="20px" width="30px " />
                                </div>
                                <div
                                    className="icons"
                                    onClick={() => {
                                        window.open(globalVal.instagram, '_blank');
                                        // this.GAAndFBEventsHandler('Footer', 'Instagram');
                                    }}
                                >
                                    <img src={Insta} alt="Instagram icon" height="20px" width="30px " />
                                </div>
                                <div
                                    className="icons"
                                    onClick={() => {
                                        window.open(globalVal.youtube, '_blank');
                                        // this.GAAndFBEventsHandler('Footer', 'YouTube');
                                    }}
                                >
                                    <img src={YT} alt="Youtube icon" height="20px" width="30px " />
                                </div>
                                <div
                                    className="icons"
                                    onClick={() => {
                                        window.open(globalVal.twitter, '_blank');
                                        // this.GAAndFBEventsHandler('Footer', 'Twitter');
                                    }}
                                >
                                    <img src={Twitter} alt="Twitter icon" height="20px" width="30px " />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="Line1"></div>
                    <div className="bootomText">
                        © 2023 RCN Telecom Services, LLC | © 2023 Grande Communications Networks, LLC | 2023 enTouch
                        Systems, Inc | 2023 WaveDivision Holdings, LLC All Rights Reserved.
                    </div>
                    {/* <div className="bootomIconFoterSmall">
                        <div className="trustpilotFooter1">
                            <TrustPilot />
                        </div>
                        <div
                            className="assuredCardFooter1"
                            onClick={() => this.handleAssuranceCard()}
                            style={{ cursor: 'pointer' }}
                        >
                            <img src={AssuredCard} alt="" />
                        </div>
                    </div> */}
                </div>
            </AppBar>
        );
    }
}
